const getters = {
  app: state => state.app,
  account: state => state.account
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js